export default __webpack_public_path__ + "assets/roboto-v18-latin-300.55536c8.woff2";